import { GetProductListResponse } from "services/interface";
import styled from "@emotion/styled";
import { Row } from "antd";
import NotFoundData from "components/NotFoundData";
import React, { Dispatch, FC, SetStateAction, useEffect } from "react";
import ProductCard from "../ProductCard";
import { useAppDispatch } from "store";
import { setLoading } from "store/slices/loadingSlice";
import SearchProductForm from "../SearchProductForm";

interface ProductOnSaleProps {
  isLoading: boolean;
  data: GetProductListResponse | undefined;
  refetch: () => void;
  setSearchInput: Dispatch<SetStateAction<string>>;
  searchInput: string;
}

const ProductApprove: FC<ProductOnSaleProps> = ({
  isLoading,
  data,
  refetch,
  searchInput,
  setSearchInput
}) => {

  const dispatch = useAppDispatch();


  useEffect(() => {
    dispatch(setLoading(isLoading));
    return () => { dispatch(setLoading(false)); };
  }, [isLoading, dispatch]);


  //ยังไม่มีสินค้าในตอนนี้
  if (!data || data.products?.length === 0) {
    return  <WrapperAll> 
              <SearchProductForm searchInput={searchInput} setSearchInput={setSearchInput} />
              <NotFoundData text="ยังไม่มีสินค้าในตอนนี้" />
            </WrapperAll>;
  }

  return (
    <WrapperAll>
      <SearchProductForm searchInput={searchInput} setSearchInput={setSearchInput}/>
      <Row
        gutter={[16, 16]}
        style={{ backgroundColor: "#EFEFEF", overflow: "auto" }}
      >

      { data && data?.products?.map((item) => {
        return (
          <ProductCard
            key={item.id}
            data={item}
            refetch={refetch}
          />
        );
      })}

       
   
      </Row>
    </WrapperAll>
  );
};

export default ProductApprove;

const WrapperAll = styled.div`
  padding: 10px 0px 0px 0px;
  background-color: #efefef;
`;
